import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Layers, Zap, Check } from 'lucide-react';
import { categories, companyInfo } from '../data/mock';

const Home = () => {
  const iconMap = {
    Shield,
    Layers,
    Zap,
    Check
  };

  return (
    <div className="min-h-screen">

      {/* ================= HERO ================= */}
      <section className="relative h-[600px] flex items-start overflow-hidden">

        {/* Background */}
       <div 
        className="absolute inset-0 bg-cover bg-center"
       style={{ backgroundImage: `url('/images/hero.jpg')` }}
        >
       {/* Gradient */}
     <div className="absolute inset-0 bg-gradient-to-b from-blue-600/70 via-blue-400/40 to-transparent"></div>

       {/* Overlay */}
       <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-transparent"></div>
       </div>
        {/* Content */}
        <div className="relative max-w-7xl px-6 mx-auto w-full pt-8 md:pt-12">
          
          <div className="text-center mx-auto">

          {/* ONE LINE HERO TEXT */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white whitespace-nowrap lg:whitespace-normal overflow-hidden text-ellipsis mx-auto">
          {companyInfo.tagline}
           </h1>

         <p className="mt-4 text-base md:text-lg text-white/90 max-w-2xl mx-auto [text-shadow:0_1px_6px_rgba(0,0,0,0.5)]">
         {companyInfo.subTagline}
         </p>

          <div className="mt-10">
            <a 
              href="#products-section"
              className="inline-flex items-center px-8 py-4 bg-white text-slate-900 rounded-lg font-semibold text-lg hover:bg-slate-100 transition group"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('products-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              View Our Range
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition" />
            </a>
              </div>
          </div>

        </div>
      </section>

{/* Hero Divider */}
<div className="relative -mt-1">
  <div className="h-20 bg-gradient-to-b from-transparent via-white/70 to-white"></div>
</div>

{/* Next Section */}

      {/* ================= BENEFITS ================= */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              Why Choose Everkast NZ?
            </h2>
            <p className="text-slate-600 mt-3">
              Premium coating solutions trusted by professionals
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyInfo.benefits.map((benefit, index) => {
              const Icon = iconMap[benefit.icon];

              return (
                <div 
                  key={index}
                  className="p-6 bg-slate-50 rounded-xl border hover:shadow-md transition"
                >
                  <div className="w-12 h-12 bg-slate-900 text-white flex items-center justify-center rounded-lg mb-4">
                    <Icon size={22} />
                  </div>

                  <h3 className="font-semibold text-lg text-slate-900">
                    {benefit.title}
                  </h3>

                  <p className="text-slate-600 mt-2 text-sm">
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </section>

      {/* ================= PRODUCTS ================= */}
      <section id="products-section" className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              Our Product Range
            </h2>
            <p className="text-slate-600 mt-3">
              Explore our professional coating range
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                  />
                </div>

                <div className="p-5">
                  <h3 className="font-semibold text-lg text-slate-900 group-hover:text-black">
                    {category.name}
                  </h3>

                  <p className="text-sm text-slate-600 mt-2 line-clamp-2">
                    {category.description}
                  </p>

                  <span className="inline-flex items-center mt-4 text-sm font-medium">
                    View Products
                    <ArrowRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition" />
                  </span>
                </div>
              </Link>
            ))}
          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-20 bg-slate-900 text-center text-white">
        <div className="max-w-3xl mx-auto px-6">

          <h2 className="text-3xl md:text-4xl font-bold">
            Ready to Get Started?
          </h2>

          <p className="text-slate-300 mt-4">
            Get expert advice and the right coating solution for your project.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link 
              to="/request-quote"
              className="px-6 py-3 bg-green-600 rounded-lg hover:bg-green-700 transition"
            >
              Request Quote
            </Link>

            <Link 
              to="/contact"
              className="px-6 py-3 bg-white text-slate-900 rounded-lg hover:bg-slate-100 transition inline-flex items-center"
            >
              Contact Us
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Home;
